/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {Page} from './pages';

export interface SideSheet {
  activeSideSheet: null | string;
  desktopSideSheetOpen: boolean;
  mobileSideSheetOpen: boolean;
};
export interface SecondaryNav {
  pages: Page[];
  show: boolean;
};

export enum SidesheetPages {
  LIST = 'LIST',
  DETAIL = 'DETAIL',
  FIND_NEARBY = 'FIND_NEARBY',
  DETAIL_FIND_NEARBY = 'DETAIL_FIND_NEARBY',
  ASSOCIATED_TAG = 'ASSOCIATED_TAG'
}

export interface BreadcrumbsType {
  label: string;
  click: string;
  source?: SidesheetPages;
}
